<template>
  <div id="app">
    <div class="slider">
      <vue-slider
        height="14px"
        v-model="calculator.dayRate"
        v-on:change="fieldChanged"
        :min="calculator.slider.min"
        :max="calculator.slider.max"
        :interval="calculator.slider.interval"
        :tooltip="'always'"
        :tooltip-placement="'top'"
        :tooltip-formatter="calculator.slider.formatter"
      ></vue-slider>
      <!--        :marks="calculator.slider.marks" -->
    </div>
    <div class="results">
      <table>
        <thead>
          <tr>
            <th colspan="2">Company Income and Expenses</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Rate:</td>
            <td>{{ formatCurrency(results.Rate) }}</td>
          </tr>
          <tr>
            <td>Days/Hours:</td>
            <td>{{ results.Days }}</td>
          </tr>
          <tr>
            <td>Income:</td>
            <td>{{ formatCurrency(results.Income) }}</td>
          </tr>
          <!--<tr>
            <td>Pension Contribution:</td>
            <td>{{ formatCurrency(results.Pension) }}</td>
          </tr>-->
          <tr>
            <td>Umbrella Margin:</td>
            <td>{{ formatCurrency(results.UmbrellaMargin) }}</td>
          </tr>
          <tr>
            <td>Employers NI:</td>
            <td>{{ formatCurrency(results.EmployersNI) }}</td>
          </tr>
          <tr>
            <td>Apprentice Levy:</td>
            <td>{{ formatCurrency(results.ApprenticeLevy) }}</td>
          </tr>
        </tbody>

        <thead>
          <tr>
            <th colspan="2">Employee Payment</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Taxable Pay:</td>
            <td>{{ formatCurrency(results.TaxablePay) }}</td>
          </tr>
          <tr>
            <td>PAYE Income Tax:</td>
            <td>{{ formatCurrency(results.PAYEIncomeTax) }}</td>
          </tr>
          <tr>
            <td>Employees NI:</td>
            <td>{{ formatCurrency(results.EmployeesNI) }}</td>
          </tr>
          <!-- <tr>
            <td>Employees Pensions:</td>
            <td>{{ formatCurrency(results.EmployeesPensions) }}</td>
          </tr>
          <tr>
            <td>Student Loan:</td>
            <td>{{ formatCurrency(results.StudentLoan) }}</td>
          </tr>
          -->
          <tr class="total">
            <td>Net Payment:</td>
            <td>{{ formatCurrency(results.NETPayment) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  name: "salary-calculator",
  components: {
    VueSlider,
  },
  data: function () {
    return {
      data: {
        source: "data/salary-tables.csv",
        table: null,
      },
      calculator: {
        dayRate: 300,
        slider: {
          formatter: "£{value}",
          min: 150,
          max: 1000,
          interval: 50,
          marks: [150, 200, 250, 300],
        },
      },
      results: {},
    };
  },

  async mounted() {
    this.data.table = await this.loadData(this.data.source);
    // this.addMarks();
    this.fieldChanged();
  },

  methods: {
    loadData: async function (dataFile) {
      return new Promise((resolve) => {
        this.$papa.parse(dataFile, {
          download: true,
          header: true,
          dynamicTyping: true,
          complete: (results) => {
            resolve(results.data);
          },
        });
      });
    },

    // addMarks: function () {
    //   this.data.table.forEach((element) => {
    //     this.calculator.slider.marks.push(element.Rate);
    //   });
    // },

    fieldChanged: function () {
      this.data.table.forEach((element) => {
        if (element.Rate == this.calculator.dayRate) {
          this.results = element;
          return;
        }
      });
    },

    formatCurrency: function (number) {
      if (number !== "" && number !== undefined) {
        return number.toLocaleString("en-GB", {
          style: "currency",
          currency: "GBP",
          maximumFractionDigits: 2,
        });
      }
      return false;
    },
  },
};
</script>


